import {INSERT_PLACEHOLDER_ID} from '../constants'
import {ResourceID} from '../types'

export const shouldDoCreate = ({
  ID,
}: {
  ID: ResourceID | null | undefined
}): boolean => !ID || ID === INSERT_PLACEHOLDER_ID
